export default function uniqId(prefixValues = '') {
  const prefix = Object.values(prefixValues).join('');
  const dateRadix = Number(new Date()).toString(36);
  const randomRadix = Math.random().toString(36).replace('0.', '');
  return prefix + dateRadix + randomRadix;
}
